import { Box, Button, Flex, Group, Text } from '@mantine/core';
import { IconDownload, IconFileText } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { PresentedFile } from '../chat/types';

type Props = {
  file: PresentedFile;
};

export function PresentedFileCard({ file }: Props) {
  return (
    <Box bg="orange.1" p="md" style={{ borderRadius: 'var(--mantine-radius-md)' }}>
      <Flex direction="column" gap="sm">
        <Group gap="xs" align="center">
          <IconFileText size={16} stroke={1.5} color="var(--mantine-color-orange-7)" aria-hidden />
          <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.9">
            {file.description}
          </Text>
        </Group>
        <Button
          component="a"
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          variant="filled"
          color="orange"
          size="sm"
          leftSection={<IconDownload size={14} />}
          style={{ alignSelf: 'flex-start' }}
        >
          Download
        </Button>
      </Flex>
    </Box>
  );
}
